var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{class:'sticky left-0 z-20',attrs:{"background":'bg-white hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-800'}},[_vm._v("\n    "+_vm._s(_vm.$t('general.actions'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }